    <!-- search bar -->
    <app-keyword-search></app-keyword-search>
    <div class="content-wrap">
        <div class="container">
            <div class="breadcrumb">
                <a style="margin-right: 2px;" href="">home</a> > Partenaire > Ma fiche "Adhérent"
            </div>
            <div class="title-catalogue d-flex justify-content-between align-items-center flex-wrap">
                <h2>MA FICHE "PARTENAIRE"</h2>
                <span class="btn-common btn-modal" href="">ENREGISTRER</span>
            </div>
            <div class="informations-partenaires d-flex mb-8 flex-wrap">
                <div class="col-md-3 informations-title mb-2">
                    Informations Partenaire
                </div> 
                <div class="col-md-9 informations-content">
                    <h3>Informations Partenaires</h3>
                    <div class="informations-form">
                        <div class="row">
                            <div class="col-md-5 mb-3">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">Raison sociale</label>
                                    <input type="text" placeholder="Raison sociale">
                                </div>
                            </div>
                            <div class="col-md-7 mb-3">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">SIRET</label>
                                    <input type="text" placeholder="SIRET">
                                </div>
                            </div>
                        </div>
                        <div class="row mb-5">
                            <div class="col-md-12">
                                <div class="wrap-input-file">
                                    <span>Votre logo</span>
                                    <label  for="votre-logo">
                                        SÉLECTIONNER VOTRE FICHIER
                                        <input  (change)="uploadFile($event)" type="file" id="votre-logo" placeholder="Raison sociale">
                                    </label>
                                    <strong class="ml-2">{{namefile}}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 mb-5">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">Adresse</label>
                                    <input type="text" placeholder="Adresse">
                                </div>
                            </div>
                            <div class="col-md-4 mb-5">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">Complément d'adresse</label>
                                    <input type="text" placeholder="Complément d'adresse">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 mb-5">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">Code postal</label>
                                    <input type="text" placeholder="Code postal">
                                </div>
                            </div>
                            <div class="col-md-4 mb-5">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">Ville</label>
                                    <input type="text" placeholder="Ville">
                                </div>
                            </div>
                            <div class="col-md-4 mb-5">
                                <div class="wrap-select">
                                    <label for="Pays">Pays</label>
                                    <p-dropdown class="w-12"  optionLabel="title"
                                        placeholder="Pays"></p-dropdown>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 mb-5">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">Téléphone</label>
                                    <input type="text" placeholder="Téléphone">
                                </div>
                            </div>
                            <div class="col-md-4 mb-5">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">Fax</label>
                                    <input type="text" placeholder="Fax">
                                </div>
                            </div>
                            <div class="col-md-4 mb-5">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">E-mail</label>
                                    <input type="text" placeholder="E-mail">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>